<tabset    
    [ngClass]="cardClass() ? cardClass() : ''"
    [justified]="true">
    @for (tab of tabData(); track $index) {
        <tab customClass="h-100">
            <ng-template tabHeading>
                <presenter [data]="tab" key="title" class="static-full-width"></presenter>
            </ng-template>
            <presenter [data]="tab"></presenter>
        </tab>
    }
</tabset>
